import { Api } from "./api";
import PropTypes from "prop-types";
import React from "react";

const BRAND = "vw";
const COUNTRY = "de";

class CustomerInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidUpdate() {
    this.fetch();
  }

  componentDidMount() {
    this.fetch();
  }

  fetch() {
    const { onReceived, onError, data, getTransactionIdPromise } = this.props;

    if (!data.webCalc) {
      onError(
        new Error(
          "Failed to create customer information request due to missing webCALC information"
        )
      );
      return;
    }

    const payload = {
      country: COUNTRY,
      brand: BRAND,
      customerData: {
        salutation: data.salutation,
        title: data.title,
        firstName: data.firstName,
        lastName: data.lastName,
        birthName: data.maidenName,
        addresses: [
          {
            city: data.city,
            countryCode: data.country,
            houseNumber: data.housenumber,
            street: data.street,
            zipCode: data.postcode,
          },
          ...(!data.prevstreet
            ? []
            : [
                {
                  city: data.prevcity,
                  countryCode: data.prevcountry,
                  houseNumber: data.prevhousenumber,
                  street: data.prevstreet,
                  zipCode: data.prevpostcode,
                },
              ]),
        ],
      },
      financialProduct: {
        staticCosts: {
          yearlyGeneralAmount: data.webCalc.yearlyGeneralAmount,
          yearlyAdministrationAmount: data.webCalc.yearlyAdministrationAmount,
          distributionAmount: data.webCalc.distributionAmount,
        },
      },
    };

    const hash = JSON.stringify(payload);

    if (hash !== this.state.hash) {
      this.setState({ hash });

      const api = Api.fromSession(getTransactionIdPromise);

      api.fetchCustomerInfoDocsAsync(payload).then(
        (documents) => {
          this.setState({ documents, hash });
          onReceived();
        },
        (err) => {
          console.error(
            "An error occurred while loading customer information documents.",
            err && err.message
          );

          if (onError) {
            onError(err);
          }
        }
      );
    }
  }

  render() {
    const { render } = this.props;
    const { documents } = this.state;

    return render
      ? render({
          documents: documents
            ? documents.map(({ name, url }) => ({
                name,
                href: url,
              }))
            : [],
        })
      : null;
  }
}

CustomerInfo.propTypes = {
  data: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
  getTransactionIdAsync: PropTypes.func,
  onError: PropTypes.func,
};

export { CustomerInfo };
